<template>
  <div :class="['ButtonGroup', { alignCenter: variant.align === 'center' }]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  props: {
    variant: {
      type: Object,
      default: () => ({}),
    },
  },
  created () {},
  components: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.ButtonGroup {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.alignCenter {
  justify-content: center;
}
.ButtonGroup > * + * {
  margin-left: 10px;
}
</style>
